<template>
  <tags
    :model-value="getTemplateTags"
    :manage-tags-url="manageTagsUrl"
    @change="handleTagChange"
  >
    <template #trigger="{ hasSelection, isOpen, toggle }">
      <button
        type="button"
        class="btn btn-sm btn-icon btn-style-b"
        :class="{ 'btn-style-a': isOpen || hasSelection }"
        aria-label="Toggle tags"
        aria-haspopup="true"
        :aria-expanded="isOpen ? 'true' : 'false'"
        data-test="tags-button-open"
        @click="toggle"
      >
        <span class="far fa-tag" />
      </button>
    </template>
  </tags>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import Tags from './Tags.vue';

export default {
  name: 'GraphicsTags',

  components: {
    Tags,
  },

  computed: {
    ...mapGetters('graphicsTemplate', ['getTemplateTags']),

    manageTagsUrl() {
      return `${process.env.TAGLANDIA_URL}/settings/tags`;
    },
  },

  methods: {
    ...mapActions('graphicsTemplate', ['addTemplateTag', 'removeTemplateTag']),

    handleTagChange(payload = {}) {
      const { addedTags = [], removedTags = [] } = payload;

      removedTags
        .filter(Boolean)
        .forEach((tagName) => {
          this.removeTemplateTag({ value: tagName });
        });

      addedTags
        .filter(Boolean)
        .forEach((tagName) => {
          this.addTemplateTag({ value: tagName });
        });
    },
  },
};
</script>
